var _style, _defs, _path, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 216 216",
    style: {
      enableBackground: "new 0 0 216 216"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st6{fill:inherit}")), /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_389_",
    d: "M129.43 169.66h-5.34c-.46-.21-.96-.18-1.45-.19-10.5-.07-21-.01-31.51-.12-13.11-.14-26.23-.05-39.34-.06-1.61 0-1.61 0-1.61-1.57.01-19.04.02-38.09.04-57.13 0-.46.04-.92.06-1.38.03-.64.27-.83.86-.45.88.56 1.75 1.15 2.68 1.62.89.45 1.18 1.08 1.16 2.06-.1 5.53.01 11.05-.13 16.58-.14 5.8-.04 11.61-.04 17.41 0 .29-.1.6.12.87.25-.1.25-.34.32-.53 4.48-12.81 8.95-25.63 13.45-38.44.32-.92.13-1.44-.64-2.01-5.3-3.93-10.55-7.94-15.88-11.84-1.1-.8-1.47-1.66-1.47-2.99.04-14.43.03-28.87.17-43.3.02-1.86 0-1.86 1.88-1.86 23.09.07 46.19-.08 69.28.13 7.57.07 14.81 1.6 21.77 4.52 8.88 3.73 14.5 10.17 16.49 19.68.89 4.25 1.01 8.53.55 12.83-.36 3.34-.95 6.63-2.41 9.7-2.01 4.24-5.14 7.53-8.82 10.34-.89.68-.89.78.06 1.29 1.25.67 2.43 1.44 3.59 2.25 6.6 4.64 10.78 10.82 12.03 18.87.73 4.68.65 9.37-.05 14.04-.44 2.91-.85 5.86-2.18 8.54-2.38 4.8-5.63 8.93-9.88 12.22-5.66 4.39-12.22 6.73-19.15 8.17-1.51.34-3.07.51-4.61.75zM117.41 51.53c-.8 0-1.6-.03-2.39.01-.53.03-1.27-.3-1.54.23-.26.5.37.98.65 1.43 9.65 15.62 19.31 31.23 28.97 46.84.62 1.01.65 1.02 1.55.26 7.68-6.45 11.75-14.55 11.34-24.73-.22-5.3-2.07-9.88-5.79-13.65-3.53-3.58-7.88-5.81-12.57-7.44-6.55-2.28-13.31-3.1-20.22-2.95zM63.56 164.87c.31.28.64.19.93.19 10.35.08 20.69-.04 31.04.12 9.06.14 18.12 0 27.17.05 4.4.02 8.67-.73 12.92-1.74.25-.06.62-.03.7-.35.08-.32-.27-.45-.47-.62-4.07-3.7-8.13-7.39-12.21-11.08-5.19-4.7-10.38-9.39-15.56-14.1-.51-.46-.92-.45-1.47-.1-1.28.85-2.59 1.65-3.88 2.48-12.71 8.12-25.41 16.23-38.11 24.35-.34.23-.75.38-1.06.8zm-6.12-2.98c.33.08.52-.15.75-.29 2.72-1.74 5.43-3.49 8.14-5.23 11.99-7.7 23.98-15.4 35.98-23.1.9-.58.91-.59.06-1.23-8.97-6.72-17.94-13.44-26.92-20.16-.83-.62-.9-.6-1.24.38-5.54 16.22-11.07 32.44-16.6 48.66-.11.31-.33.62-.17.97zm30.02-78.34c-.52.2-.17.53-.05.76 1.1 2.16 2.21 4.32 3.32 6.48 6.11 11.91 12.22 23.83 18.33 35.74.6 1.18.67 1.18 1.7.33 6.51-5.43 13.02-10.85 19.53-16.28 1.91-1.59 3.83-3.18 5.73-4.78.79-.66.76-.78-.18-1.22-.08-.04-.17-.08-.25-.12-15.8-6.87-31.6-13.74-47.39-20.61-.24-.09-.46-.18-.74-.3zm48.14 15.31c.09-.49-.12-.71-.25-.94-8.43-14.31-16.87-28.62-25.31-42.93-.57-.97-.67-.98-1.46-.18-2.98 3.01-5.95 6.04-8.93 9.04-4.39 4.42-8.8 8.83-13.2 13.24-.96.96-.95.98.28 1.49 15.17 6.3 30.34 12.6 45.51 18.89 1.08.47 2.18.91 3.36 1.39zm8.79 35.06h-.04v25.24c0 1.22.07 1.26 1.17.71 5.98-2.98 9.83-7.92 12.6-13.81 2.46-5.21 3.16-10.71 2.65-16.43-.61-6.89-3.02-12.79-8.64-17.14-2.17-1.68-4.47-3.13-6.86-4.46-.71-.4-.94-.18-.89.56.02.24 0 .49 0 .74.01 8.19.01 16.39.01 24.59zm-5.21 18.58c.08-2.18-.13-4.36-.14-6.53-.08-11.17-.14-22.34-.22-33.51 0-.29.14-.7-.15-.86-.32-.17-.52.24-.74.42-8.28 6.84-16.55 13.7-24.82 20.55-1.04.86-1.03.88-.04 1.76 6.29 5.63 12.57 11.26 18.85 16.89 2.12 1.9 4.24 3.82 6.38 5.71.21.19.41.57.75.4.26-.13.14-.51.14-.77-.01-1.36-.01-2.71-.01-4.06zM104.71 51.64c-.05-.08-.1-.16-.15-.23-.21-.02-.42-.06-.63-.06-6.72-.12-13.45-.25-20.17-.35-6.63-.1-13.26-.16-19.9-.24-.37 0-.74-.05-1.1-.06-2-.03-3.99-.07-5.99-.09-.2 0-.48-.07-.56.19-.07.24.18.37.32.52.15.16.3.3.46.45 3.43 3.25 6.86 6.51 10.3 9.76 4.44 4.2 8.88 8.39 13.3 12.61.49.47.82.48 1.29 0 1.21-1.22 2.47-2.39 3.69-3.6 5.57-5.51 11.13-11.02 16.7-16.52.82-.81 1.63-1.59 2.44-2.38zm-4.16 72.44c.02-.38-.15-.64-.28-.91-6.18-13.28-12.37-26.56-18.55-39.83-.47-1-.5-1.01-1.29-.21L66.05 97.54c-.92.92-.92 1.02.16 1.8 11.15 8.12 22.29 16.23 33.44 24.34.24.16.46.41.9.4zm-44.8-40.57h-.3c0 2.24.02 4.48-.01 6.72-.01.53.21.86.59 1.16 1.43 1.11 2.86 2.22 4.27 3.35.44.36.77.36 1.19-.04 5.13-5.03 10.26-10.05 15.41-15.05.54-.53.44-.86-.07-1.34-3.81-3.56-7.6-7.14-11.4-10.71l-8.73-8.19c-.17-.16-.34-.46-.59-.38-.33.11-.19.48-.21.73-.06 1.29-.14 2.57-.14 3.86-.02 6.63-.01 13.26-.01 19.89z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_389_",
    style: {
      overflow: "visible",
      fill: "inherit"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_1_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_389_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M55.42 58.95h1.07v36.16h-1.07zM56.49 58.95h2.1v36.16h-2.1zM58.6 58.95h2.1v36.16h-2.1zM60.7 58.95h2.1v36.16h-2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M62.8 58.95h2.1v36.16h-2.1zM64.91 58.95h2.1v36.16h-2.1zM67.01 58.95h2.1v36.16h-2.1zM69.12 58.95h2.1v36.16h-2.1zM71.22 58.95h2.1v36.16h-2.1zM73.33 58.95h2.1v36.16h-2.1zM75.43 58.95h2v36.16h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M65.13 82.32h1.88v41.77h-1.88zM67.01 82.32h2.1v41.77h-2.1zM69.12 82.32h2.1v41.77h-2.1zM71.22 82.32h2.1v41.77h-2.1zM73.33 82.32h2.1v41.77h-2.1zM75.43 82.32h2.1v41.77h-2.1zM77.53 82.32h2.1v41.77h-2.1zM79.64 82.32h2.1v41.77h-2.1zM81.74 82.32h2.1v41.77h-2.1zM83.85 82.32h2.1v41.77h-2.1zM85.95 82.32h2.1v41.77h-2.1zM88.06 82.32h2.1v41.77h-2.1zM90.16 82.32h2.1v41.77h-2.1zM92.26 82.32h2.1v41.77h-2.1zM94.37 82.32h2.1v41.77h-2.1zM96.47 82.32h2.1v41.77h-2.1zM98.58 82.32h2v41.77h-2zM56.15 50.53h.35v24.08h-.35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M56.49 50.53h2.1v24.08h-2.1zM58.6 50.53h2.1v24.08h-2.1zM60.7 50.53h2.1v24.08h-2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M62.8 50.53h2.1v24.08h-2.1zM64.91 50.53h2.1v24.08h-2.1zM67.01 50.53h2.1v24.08h-2.1zM69.12 50.53h2.1v24.08h-2.1zM71.22 50.53h2.1v24.08h-2.1zM73.33 50.53h2.1v24.08h-2.1zM75.43 50.53h2.1v24.08h-2.1zM77.53 50.53h2.1v24.08h-2.1zM79.64 50.53h2.1v24.08h-2.1zM81.74 50.53h2.1v24.08h-2.1zM83.85 50.53h2.1v24.08h-2.1zM85.95 50.53h2.1v24.08h-2.1zM88.06 50.53h2.1v24.08h-2.1zM90.16 50.53h2.1v24.08h-2.1zM92.26 50.53h2.1v24.08h-2.1zM94.37 50.53h2.1v24.08h-2.1zM96.47 50.53h2.1v24.08h-2.1zM98.58 50.53h2.1v24.08h-2.1zM100.68 50.53h2.1v24.08h-2.1zM102.79 50.53h1.92v24.08h-1.92zM112.07 111.43h.09v46.07h-.09zM112.16 111.43h1.02v46.07h-1.02zM113.18 111.43h1.02v46.07h-1.02zM114.2 111.43h1.02v46.07h-1.02zM115.22 111.43h1.02v46.07h-1.02zM116.24 111.43h1.02v46.07h-1.02zM117.26 111.43h1.02v46.07h-1.02zM118.28 111.43h1.02v46.07h-1.02zM119.3 111.43h1.02v46.07h-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M120.31 111.43h1.02v46.07h-1.02zM121.33 111.43h1.02v46.07h-1.02zM122.35 111.43h1.02v46.07h-1.02zM123.37 111.43h1.02v46.07h-1.02zM124.39 111.43h1.02v46.07h-1.02zM125.41 111.43h1.02v46.07h-1.02zM126.43 111.43h1.02v46.07h-1.02zM127.45 111.43h1.02v46.07h-1.02zM128.47 111.43h1.02v46.07h-1.02zM129.49 111.43h1.02v46.07h-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M130.51 111.43h1.02v46.07h-1.02zM131.53 111.43h1.02v46.07h-1.02zM132.55 111.43h1.02v46.07h-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M133.57 111.43h1.02v46.07h-1.02zM134.59 111.43h1.02v46.07h-1.02zM135.61 111.43h1.02v46.07h-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M136.63 111.43h1.02v46.07h-1.02zM137.65 111.43h1.02v46.07h-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M138.67 111.43h.63v46.07h-.63zM144.34 107.63h.45v52.79h-.45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M144.78 107.63h1.02v52.79h-1.02zM145.8 107.63h1.02v52.79h-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M146.82 107.63h1.02v52.79h-1.02zM147.84 107.63h1.02v52.79h-1.02zM148.86 107.63h1.02v52.79h-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M149.88 107.63h1.02v52.79h-1.02zM150.9 107.63h1.02v52.79h-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M151.92 107.63h1.02v52.79h-1.02zM152.94 107.63h1.02v52.79h-1.02zM153.96 107.63h1.02v52.79h-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M154.98 107.63H156v52.79h-1.02zM156 107.63h1.02v52.79H156zM157.02 107.63h1.02v52.79h-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M158.04 107.63h1.02v52.79h-1.02zM159.06 107.63h1.02v52.79h-1.02zM160.08 107.63h1.02v52.79h-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M161.1 107.63h.18v52.79h-.18zM85.47 54.02h.48v44.84h-.48zM85.95 54.02h2.1v44.84h-2.1zM88.06 54.02h2.1v44.84h-2.1zM90.16 54.02h2.1v44.84h-2.1zM92.26 54.02h2.1v44.84h-2.1zM94.37 54.02h2.1v44.84h-2.1zM96.47 54.02h2.1v44.84h-2.1zM98.58 54.02h2.1v44.84h-2.1zM100.68 54.02h2.1v44.84h-2.1zM102.79 54.02h2.1v44.84h-2.1zM104.89 54.02h2.1v44.84h-2.1zM107 54.02h2.1v44.84H107zM109.1 54.02h1.02v44.84h-1.02zM110.12 54.02h1.02v44.84h-1.02zM111.14 54.02h1.02v44.84h-1.02zM112.16 54.02h1.02v44.84h-1.02zM113.18 54.02h1.02v44.84h-1.02zM114.2 54.02h1.02v44.84h-1.02zM115.22 54.02h1.02v44.84h-1.02zM116.24 54.02h1.02v44.84h-1.02zM117.26 54.02h1.02v44.84h-1.02zM118.28 54.02h1.02v44.84h-1.02zM119.3 54.02h1.02v44.84h-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M120.31 54.02h1.02v44.84h-1.02zM121.33 54.02h1.02v44.84h-1.02zM122.35 54.02h1.02v44.84h-1.02zM123.37 54.02h1.02v44.84h-1.02zM124.39 54.02h1.02v44.84h-1.02zM125.41 54.02h1.02v44.84h-1.02zM126.43 54.02h1.02v44.84h-1.02zM127.45 54.02h1.02v44.84h-1.02zM128.47 54.02h1.02v44.84h-1.02zM129.49 54.02h1.02v44.84h-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M130.51 54.02h1.02v44.84h-1.02zM131.53 54.02h1.02v44.84h-1.02zM132.55 54.02h1.02v44.84h-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M133.57 54.02h1.02v44.84h-1.02zM134.59 54.02h1.02v44.84h-1.02zM135.61 54.02h.08v44.84h-.08zM86.94 83.55h1.12v44.17h-1.12zM88.06 83.55h2.1v44.17h-2.1zM90.16 83.55h2.1v44.17h-2.1zM92.26 83.55h2.1v44.17h-2.1zM94.37 83.55h2.1v44.17h-2.1zM96.47 83.55h2.1v44.17h-2.1zM98.58 83.55h2.1v44.17h-2.1zM100.68 83.55h2.1v44.17h-2.1zM102.79 83.55h2.1v44.17h-2.1zM104.89 83.55h2.1v44.17h-2.1zM107 83.55h2.1v44.17H107zM109.1 83.55h1.02v44.17h-1.02zM110.12 83.55h1.02v44.17h-1.02zM111.14 83.55h1.02v44.17h-1.02zM112.16 83.55h1.02v44.17h-1.02zM113.18 83.55h1.02v44.17h-1.02zM114.2 83.55h1.02v44.17h-1.02zM115.22 83.55h1.02v44.17h-1.02zM116.24 83.55h1.02v44.17h-1.02zM117.26 83.55h1.02v44.17h-1.02zM118.28 83.55h1.02v44.17h-1.02zM119.3 83.55h1.02v44.17h-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M120.31 83.55h1.02v44.17h-1.02zM121.33 83.55h1.02v44.17h-1.02zM122.35 83.55h1.02v44.17h-1.02zM123.37 83.55h1.02v44.17h-1.02zM124.39 83.55h1.02v44.17h-1.02zM125.41 83.55h1.02v44.17h-1.02zM126.43 83.55h1.02v44.17h-1.02zM127.45 83.55h1.02v44.17h-1.02zM128.47 83.55h1.02v44.17h-1.02zM129.49 83.55h1.02v44.17h-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M130.51 83.55h1.02v44.17h-1.02zM131.53 83.55h1.02v44.17h-1.02zM132.55 83.55h1.02v44.17h-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M133.57 83.55h1.02v44.17h-1.02zM134.59 83.55h1.02v44.17h-1.02zM135.61 83.55h1.02v44.17h-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M136.63 83.55h.17v44.17h-.17zM57.28 111.27h1.31v50.71h-1.31zM58.6 111.27h2.1v50.71h-2.1zM60.7 111.27h2.1v50.71h-2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M62.8 111.27h2.1v50.71h-2.1zM64.91 111.27h2.1v50.71h-2.1zM67.01 111.27h2.1v50.71h-2.1zM69.12 111.27h2.1v50.71h-2.1zM71.22 111.27h2.1v50.71h-2.1zM73.33 111.27h2.1v50.71h-2.1zM75.43 111.27h2.1v50.71h-2.1zM77.53 111.27h2.1v50.71h-2.1zM79.64 111.27h2.1v50.71h-2.1zM81.74 111.27h2.1v50.71h-2.1zM83.85 111.27h2.1v50.71h-2.1zM85.95 111.27h2.1v50.71h-2.1zM88.06 111.27h2.1v50.71h-2.1zM90.16 111.27h2.1v50.71h-2.1zM92.26 111.27h2.1v50.71h-2.1zM94.37 111.27h2.1v50.71h-2.1zM96.47 111.27h2.1v50.71h-2.1zM98.58 111.27h2.1v50.71h-2.1zM100.68 111.27h2.1v50.71h-2.1zM102.79 111.27h.43v50.71h-.43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M63.56 136.88h1.35v28.44h-1.35zM64.91 136.88h2.1v28.44h-2.1zM67.01 136.88h2.1v28.44h-2.1zM69.12 136.88h2.1v28.44h-2.1zM71.22 136.88h2.1v28.44h-2.1zM73.33 136.88h2.1v28.44h-2.1zM75.43 136.88h2.1v28.44h-2.1zM77.53 136.88h2.1v28.44h-2.1zM79.64 136.88h2.1v28.44h-2.1zM81.74 136.88h2.1v28.44h-2.1zM83.85 136.88h2.1v28.44h-2.1zM85.95 136.88h2.1v28.44h-2.1zM88.06 136.88h2.1v28.44h-2.1zM90.16 136.88h2.1v28.44h-2.1zM92.26 136.88h2.1v28.44h-2.1zM94.37 136.88h2.1v28.44h-2.1zM96.47 136.88h2.1v28.44h-2.1zM98.58 136.88h2.1v28.44h-2.1zM100.68 136.88h2.1v28.44h-2.1zM102.79 136.88h2.1v28.44h-2.1zM104.89 136.88h2.1v28.44h-2.1zM107 136.88h2.1v28.44H107zM109.1 136.88h1.02v28.44h-1.02zM110.12 136.88h1.02v28.44h-1.02zM111.14 136.88h1.02v28.44h-1.02zM112.16 136.88h1.02v28.44h-1.02zM113.18 136.88h1.02v28.44h-1.02zM114.2 136.88h1.02v28.44h-1.02zM115.22 136.88h1.02v28.44h-1.02zM116.24 136.88h1.02v28.44h-1.02zM117.26 136.88h1.02v28.44h-1.02zM118.28 136.88h1.02v28.44h-1.02zM119.3 136.88h1.02v28.44h-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M120.31 136.88h1.02v28.44h-1.02zM121.33 136.88h1.02v28.44h-1.02zM122.35 136.88h1.02v28.44h-1.02zM123.37 136.88h1.02v28.44h-1.02zM124.39 136.88h1.02v28.44h-1.02zM125.41 136.88h1.02v28.44h-1.02zM126.43 136.88h1.02v28.44h-1.02zM127.45 136.88h1.02v28.44h-1.02zM128.47 136.88h1.02v28.44h-1.02zM129.49 136.88h1.02v28.44h-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M130.51 136.88h1.02v28.44h-1.02zM131.53 136.88h1.02v28.44h-1.02zM132.55 136.88h1.02v28.44h-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M133.57 136.88h1.02v28.44h-1.02zM134.59 136.88h1.02v28.44h-1.02zM135.61 136.88h.8v28.44h-.8zM113.22 51.24h.97v49.83h-.97zM114.2 51.24h1.02v49.83h-1.02zM115.22 51.24h1.02v49.83h-1.02zM116.24 51.24h1.02v49.83h-1.02zM117.26 51.24h1.02v49.83h-1.02zM118.28 51.24h1.02v49.83h-1.02zM119.3 51.24h1.02v49.83h-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M120.31 51.24h1.02v49.83h-1.02zM121.33 51.24h1.02v49.83h-1.02zM122.35 51.24h1.02v49.83h-1.02zM123.37 51.24h1.02v49.83h-1.02zM124.39 51.24h1.02v49.83h-1.02zM125.41 51.24h1.02v49.83h-1.02zM126.43 51.24h1.02v49.83h-1.02zM127.45 51.24h1.02v49.83h-1.02zM128.47 51.24h1.02v49.83h-1.02zM129.49 51.24h1.02v49.83h-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M130.51 51.24h1.02v49.83h-1.02zM131.53 51.24h1.02v49.83h-1.02zM132.55 51.24h1.02v49.83h-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M133.57 51.24h1.02v49.83h-1.02zM134.59 51.24h1.02v49.83h-1.02zM135.61 51.24h1.02v49.83h-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M136.63 51.24h1.02v49.83h-1.02zM137.65 51.24h1.02v49.83h-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M138.67 51.24h1.02v49.83h-1.02zM139.69 51.24h1.02v49.83h-1.02zM140.71 51.24h1.02v49.83h-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M141.73 51.24h1.02v49.83h-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M142.74 51.24h1.02v49.83h-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M143.76 51.24h1.02v49.83h-1.02zM144.78 51.24h1.02v49.83h-1.02zM145.8 51.24h1.02v49.83h-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M146.82 51.24h1.02v49.83h-1.02zM147.84 51.24h1.02v49.83h-1.02zM148.86 51.24h1.02v49.83h-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M149.88 51.24h1.02v49.83h-1.02zM150.9 51.24h1.02v49.83h-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M151.92 51.24h1.02v49.83h-1.02zM152.94 51.24h1.02v49.83h-1.02zM153.96 51.24h1.02v49.83h-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M154.98 51.24H156v49.83h-1.02zM156 51.24h.4v49.83h-.4zM50.18 46.26h2.1v123.4h-2.1zM52.28 46.26h2.1v123.4h-2.1zM54.39 46.26h2.1v123.4h-2.1zM56.49 46.26h2.1v123.4h-2.1zM58.6 46.26h2.1v123.4h-2.1zM60.7 46.26h2.1v123.4h-2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M62.8 46.26h2.1v123.4h-2.1zM64.91 46.26h2.1v123.4h-2.1zM67.01 46.26h2.1v123.4h-2.1zM69.12 46.26h2.1v123.4h-2.1zM71.22 46.26h2.1v123.4h-2.1zM73.33 46.26h2.1v123.4h-2.1zM75.43 46.26h2.1v123.4h-2.1zM77.53 46.26h2.1v123.4h-2.1zM79.64 46.26h2.1v123.4h-2.1zM81.74 46.26h2.1v123.4h-2.1zM83.85 46.26h2.1v123.4h-2.1zM85.95 46.26h2.1v123.4h-2.1zM88.06 46.26h2.1v123.4h-2.1zM90.16 46.26h2.1v123.4h-2.1zM92.26 46.26h2.1v123.4h-2.1zM94.37 46.26h2.1v123.4h-2.1zM96.47 46.26h2.1v123.4h-2.1zM98.58 46.26h2.1v123.4h-2.1zM100.68 46.26h2.1v123.4h-2.1zM102.79 46.26h2.1v123.4h-2.1zM104.89 46.26h2.1v123.4h-2.1zM107 46.26h2.1v123.4H107zM109.1 46.26h1.02v123.4h-1.02zM110.12 46.26h1.02v123.4h-1.02zM111.14 46.26h1.02v123.4h-1.02zM112.16 46.26h1.02v123.4h-1.02zM113.18 46.26h1.02v123.4h-1.02zM114.2 46.26h1.02v123.4h-1.02zM115.22 46.26h1.02v123.4h-1.02zM116.24 46.26h1.02v123.4h-1.02zM117.26 46.26h1.02v123.4h-1.02zM118.28 46.26h1.02v123.4h-1.02zM119.3 46.26h1.02v123.4h-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M120.31 46.26h1.02v123.4h-1.02zM121.33 46.26h1.02v123.4h-1.02zM122.35 46.26h1.02v123.4h-1.02zM123.37 46.26h1.02v123.4h-1.02zM124.39 46.26h1.02v123.4h-1.02zM125.41 46.26h1.02v123.4h-1.02zM126.43 46.26h1.02v123.4h-1.02zM127.45 46.26h1.02v123.4h-1.02zM128.47 46.26h1.02v123.4h-1.02zM129.49 46.26h1.02v123.4h-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M130.51 46.26h1.02v123.4h-1.02zM131.53 46.26h1.02v123.4h-1.02zM132.55 46.26h1.02v123.4h-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M133.57 46.26h1.02v123.4h-1.02zM134.59 46.26h1.02v123.4h-1.02zM135.61 46.26h1.02v123.4h-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M136.63 46.26h1.02v123.4h-1.02zM137.65 46.26h1.02v123.4h-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M138.67 46.26h1.02v123.4h-1.02zM139.69 46.26h1.02v123.4h-1.02zM140.71 46.26h1.02v123.4h-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M141.73 46.26h1.02v123.4h-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M142.74 46.26h1.02v123.4h-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M143.76 46.26h1.02v123.4h-1.02zM144.78 46.26h1.02v123.4h-1.02zM145.8 46.26h1.02v123.4h-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M146.82 46.26h1.02v123.4h-1.02zM147.84 46.26h1.02v123.4h-1.02zM148.86 46.26h1.02v123.4h-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M149.88 46.26h1.02v123.4h-1.02zM150.9 46.26h1.02v123.4h-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M151.92 46.26h1.02v123.4h-1.02zM152.94 46.26h1.02v123.4h-1.02zM153.96 46.26h1.02v123.4h-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M154.98 46.26H156v123.4h-1.02zM156 46.26h1.02v123.4H156zM157.02 46.26h1.02v123.4h-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M158.04 46.26h1.02v123.4h-1.02zM159.06 46.26h1.02v123.4h-1.02zM160.08 46.26h1.02v123.4h-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M161.1 46.26h1.02v123.4h-1.02zM162.12 46.26h1.02v123.4h-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_1_)",
      fill: "inherit"
    },
    d: "M163.14 46.26h1.02v123.4h-1.02zM164.16 46.26h1.02v123.4h-1.02zM165.18 46.26h.86v123.4h-.86z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M129.64 172.34h-6.12l-.41-.18c-.1-.01-.21 0-.31 0-4.66-.03-9.15-.03-13.63-.04-6.02-.01-12.04-.02-18.06-.08-9.13-.1-18.42-.08-27.4-.07-3.97.01-7.95.01-11.92.01-3.09 0-4.29-1.19-4.29-4.25l.03-57.13c0-.38.02-.75.05-1.13l.02-.39c.09-1.78 1.09-2.56 1.68-2.86.59-.31 1.8-.67 3.3.29l.41.26c.71.46 1.37.89 2.04 1.22 1.23.62 2.67 1.91 2.63 4.5-.05 2.57-.05 5.14-.05 7.71 0 2.96 0 5.92-.07 8.88-.03 1.07-.04 2.14-.05 3.22 2.82-8.07 5.64-16.15 8.48-24.22-2.05-1.52-4.05-3.02-6.04-4.52-3.09-2.32-6.18-4.64-9.3-6.93-1.75-1.29-2.57-2.92-2.56-5.16l.02-10.92c.02-10.62.04-21.6.15-32.41.03-3.34 1.22-4.51 4.53-4.51h.04c8.68.03 17.37.02 26.05.02 14.17-.01 28.83-.01 43.25.12 7.81.07 15.47 1.67 22.78 4.73 9.86 4.14 15.94 11.41 18.08 21.6.92 4.38 1.11 8.85.59 13.66-.32 2.99-.91 6.89-2.65 10.56-1.65 3.49-4.11 6.64-7.48 9.58.45.3.93.62 1.42.97 7.4 5.2 11.82 12.15 13.14 20.65.74 4.74.72 9.73-.05 14.85l-.04.28c-.45 2.99-.91 6.08-2.38 9.05-2.62 5.28-6.2 9.71-10.64 13.15-5.37 4.17-11.8 6.92-20.25 8.68-1.1.23-2.22.39-3.33.54-.48.07-.96.13-1.43.21l-.23.06zm-6.47-.18zm-70.31-5.54c2.87.01 5.75 0 8.63-.01l-1.53-1.37 1.45-1.96c.57-.78 1.25-1.16 1.65-1.38l39.59-25.28c.84-.53 1.68-1.06 2.51-1.61 1.58-1.04 3.36-.91 4.75.35 3.55 3.23 7.11 6.45 10.67 9.68l4.88 4.42c4.07 3.69 8.14 7.38 12.21 11.08 1.58 1.1 1.41 2.64 1.26 3.25-.08.32-.28.89-.77 1.39 2.29-.66 4.39-1.42 6.33-2.29-.44-.02-.9-.14-1.37-.43-1.44-.89-1.44-2.46-1.44-3.3v-1.03c-.34.91-1.03 1.38-1.4 1.57-.34.18-2.18 1.01-3.83-.83-1.37-1.22-2.8-2.5-4.23-3.79l-4.69-4.21c-5.41-4.85-10.83-9.71-16.25-14.55-.7-.63-1.66-1.48-1.63-2.94.03-1.46 1.02-2.28 1.75-2.88l24.73-20.47c1.66-1.78 3.44-.98 3.78-.8.56.29 1.8 1.19 1.59 3.27l.18 27.62.04-31.07c0-.09.01-.18 0-.27-.12-1.9.83-2.8 1.41-3.16.58-.37 1.8-.84 3.45.08.05.03.1.05.14.08-.22-.35-.37-.77-.42-1.28-.13-1.65 1.06-2.57 1.7-3.06 3.84-2.93 6.39-5.91 8.03-9.36 1.39-2.92 1.87-6.11 2.16-8.84.04-.38.08-.77.11-1.15-1.19 7.81-5.19 14.61-11.94 20.28-.64.54-1.61 1.36-3.02 1.12-1.41-.22-2.06-1.27-2.53-2.03l-5.34-8.63c-.23-.38-.47-.76-.7-1.14l2.88 4.88c.24.38.85 1.32.58 2.78l-.58 3.18c.65.39 1.42 1.07 1.57 2.26.21 1.65-.98 2.66-1.5 3.08-1.31 1.1-2.63 2.19-3.94 3.29l-21.32 17.77c-.7.59-1.76 1.47-3.26 1.17-1.5-.31-2.12-1.52-2.53-2.33l-14.2-27.68 10.22 21.95c.22.43.59 1.17.52 2.21l-.15 2.42-2.42.09c-.39.01-.73-.03-1.03-.11l4.35 3.26c.66.5 1.76 1.32 1.7 2.88-.06 1.56-1.22 2.3-1.92 2.75l-44.12 28.33c-.89.67-1.85.88-2.84.64l-1.27-.32-.51-1.21c-.6-1.35-.1-2.52.07-2.9 5.54-16.24 11.07-32.46 16.61-48.68.24-.71.69-2.03 2.18-2.48.28-.09.55-.13.8-.13l-3.3-2.4c.33 1.02.17 2.04-.12 2.85-3.28 9.32-6.53 18.65-9.79 27.97l-3.65 10.46c-.33 1.27-1.19 1.87-1.86 2.14l-1.8.72-1.24-1.49c0-.01-.01-.01-.01-.01l-.03 17.59zm26.73-4.21c5.26 0 10.65.01 15.98.09 5.37.08 10.84.07 16.13.05 3.67-.01 7.35-.02 11.02 0 2.89-.02 5.75-.35 8.3-.82-3.05-2.77-6.1-5.54-9.16-8.31l-4.88-4.42c-3.28-2.97-6.55-5.93-9.82-8.91l-1.65 1.05-1.31.83-31.98 20.44H79.59zm67.44-25.82v19.28c3.54-2.46 6.33-6.01 8.67-10.95 2.12-4.49 2.91-9.42 2.41-15.06-.61-6.86-3.02-11.7-7.61-15.25a44.86 44.86 0 0 0-3.43-2.4l-.04 24.38zM75.9 115.58l-13.74 40.29 36.37-23.35-22.63-16.94zm85.94 28.43c-.37 1.08-.81 2.14-1.3 3.19a39.95 39.95 0 0 1-2.85 5.11c1.12-1.54 2.12-3.19 3-4.96.52-1.05.88-2.16 1.15-3.34zm-45.68-10.5c4.98 4.46 9.96 8.92 14.93 13.38l4.69 4.21c.24.22.48.43.73.65.01-.99-.03-1.99-.08-3.04-.04-.91-.08-1.82-.08-2.73l-.19-29.04-20 16.57zM92.67 88.73l17.86 34.83 19.82-16.52c.5-.42 1.01-.84 1.51-1.26L92.67 88.73zm-23.49 9.45c8.32 6.06 16.64 12.11 24.96 18.16L80.43 86.9 69.18 98.18zm-16.23 11.17zm8.02-11.67c.59.44 1.19.89 1.78 1.34-.02-.1-.03-.21-.04-.32-.06-.8.18-1.45.52-1.97-.68.61-1.46.93-2.26.95zm56.92-43.48c7.38 11.94 14.76 23.88 22.15 35.81l4.32 6.98c6.36-5.92 9.29-12.9 8.95-21.31-.2-4.76-1.84-8.65-5.02-11.88-2.83-2.88-6.5-5.03-11.54-6.79-5.76-2-11.94-2.91-18.86-2.81zm-27.7 22.93 39.44 16.38-20.75-35.19-2.04 2.07c-1.77 1.79-3.53 3.58-5.3 5.36-2.96 2.98-5.93 5.95-8.9 8.93l-2.45 2.45zM58.11 89.62c.88.68 1.75 1.36 2.62 2.05 4.31-4.22 8.61-8.43 12.93-12.64-2.2-2.06-4.38-4.11-6.56-6.16l-3.54-3.33c-1.71-1.61-3.43-3.22-5.15-4.83-.01 4.51-.01 9.02-.01 13.53v7.94h-.3c.02 1.15.02 2.3.01 3.44zm29.97-7.56-.62 1.5.71-1.46-.09-.04zm-6.93-2.19c.17 0 .34.01.52.05 1.55.27 2.13 1.53 2.48 2.29l.44.95.06-.21c.15-.44.52-1.2 1.45-1.69l-.42-.17c-.89-.37-2.24-.93-2.56-2.52-.22-1.09.2-1.93.71-2.57l-.04.04c-1.51 1.52-3.49 1.55-5.05.06-3.19-3.04-6.4-6.07-9.6-9.11L55.15 53.71c-.24-.23-.41-.39-.58-.57-.71-.62-.97-1.31-1.04-1.91-.02 2.25-.03 4.51-.05 6.77.49-1.01 1.47-1.41 1.73-1.49.56-.2 2.03-.5 3.35 1.01 2.85 2.67 5.76 5.4 8.67 8.13l3.54 3.33c2.61 2.46 5.23 4.92 7.86 7.37.32.29 1.27 1.19 1.29 2.63 0 .46-.08.9-.27 1.31.42-.24.91-.42 1.5-.42zm-18.56-26.5 10.24 9.7c2.8 2.65 5.6 5.3 8.39 7.95l.96-.93c.51-.49 1.02-.98 1.52-1.48l14.85-14.69-.23-.01c-4.86-.09-9.73-.18-14.59-.25-4.35-.06-8.7-.11-13.05-.16l-6.84-.08c-.25 0-.49-.02-.73-.04-.18 0-.35 0-.52-.01zm71.46-2.75c1.51.38 2.99.83 4.45 1.33 5.85 2.04 10.17 4.61 13.6 8.09.65.66 1.26 1.35 1.81 2.06-2.57-3.74-6.27-6.59-11.13-8.63-2.85-1.2-5.77-2.15-8.73-2.85zm-24.71.95c.12 0 .25.01.38.02.39.05.73.16 1.03.32.01-.46.13-.92.36-1.36.28-.54.74-1.13 1.53-1.46l-6.49-.03.85 1.17 1.03 1.65c.36-.18.8-.31 1.31-.31zm-55.78-2.55c-.01.5-.01 1-.01 1.5.03-.2.07-.37.1-.5.1-.34.28-.69.53-1h-.62z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shape_7_12_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M82.04 80.55 63.53 97.77l40.59 30.39z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Shape_8_13_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M110.73 52.16 82.51 76.82l58.15 26.69z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bfa4c4ca3ec965c93065827362855383.svg";
export { ForwardRef as ReactComponent };